import { render, staticRenderFns } from "./zhiyuanzhe.vue?vue&type=template&id=1039d324&scoped=true&"
import script from "./zhiyuanzhe.vue?vue&type=script&lang=js&"
export * from "./zhiyuanzhe.vue?vue&type=script&lang=js&"
import style0 from "./zhiyuanzhe.vue?vue&type=style&index=0&id=1039d324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039d324",
  null
  
)

export default component.exports